import React, { useEffect, useState } from "react";

import { apiEndpoints } from "../../config";

import PostSingle from "../../partials/posts/postSingle";
import { Typography, Button, Stack, Box, LinearProgress } from "@mui/material";
import { getOnlineNode } from "../../core/getNode";
import { useParams } from "react-router";
import { patchNode, postNode } from "../../core/postNode";
import { useSelector } from "react-redux";

export default function PollSingle(props) {
  const [post, setPost] = useState(null);
  const [pollData, setPollData] = useState(null);
  const [vote, setVote] = useState(null);
  const params = useParams();
  const user = useSelector((state) => state).authReducer.user;

  useEffect(() => {
    getVoteData();
  }, []);

  const handleChoiceClick = (choice) => {
    if (vote !== null) {
      if (post?.cancel_vote_allow) {
        changeVote(choice.id);
      }
    } else {
      submitVote(choice.id);
    }
  };

  const getVoteData = () => {
    getOnlineNode(`${apiEndpoints.pollVote}/${params.id}?_format=hal_json`)
      .then((response) => {
        setPollData(response.data);
        if (response.data.vote !== null) {
          setVote(response.data.vote);
        }
        console.log("get poll vote response", response);
      })
      .catch((_error) => {
        console.log("get poll vote error", _error);
      });
  };

  const submitVote = (_choiceId) => {
    const data = {
      poll_id: params.id,
      choice_id: _choiceId,
    };
    postNode(`${apiEndpoints.pollVote}`, data, user.csrf_token)
      .then((response) => {
        setPollData(response.data);
      })
      .catch((error) => console.error("submit vote error", error));
  };

  const changeVote = (_choiceId) => {
    const data = {
      poll_id: params.id,
      choice_id: _choiceId,
    };
    patchNode(`${apiEndpoints.pollVote}/${params.id}`, data, user.csrf_token)
      .then((response) => {
        setPollData(response.data);
      })
      .catch((error) => console.error("submit vote error", error));
  };

  const getResultForChoice = (choiceId) => {
    return pollData?.results?.choices?.find((c) => c.id === choiceId) ?? null;
  };

  const getPercentage = (votes) => {
    const total = pollData?.results?.total_votes ?? 0;
    if (!total) return 0;
    return Math.round((votes / total) * 100);
  };

  const showResults = vote !== null;

  return (
    <PostSingle
      preview={props.preview}
      apiEndpoint={apiEndpoints.polls}
      entityFavoritesContentType={"polls"}
      previewReturnRoute={"/polls-creator"}
      returnRoute={"/polls"}
      backBtnText={"Opinion Polls Library"}
      screenClassName={"polls"}
      logCustomEventType={"polls"}
      entityType={"poll"}
      featuredImageEnabled={true}
      setEntityPost={(_post) => {
        console.log("post", _post);
        setPost(_post);
      }}
    >
      {/* Choices section */}
      { post?.choices && post.choices.length > 0 && (
        <Stack spacing={1} sx={{ mt: 2 }}>
          {post.choices.map((choice) => (
            <Button
              key={choice.id}
              variant="outlined"
              fullWidth
              onClick={() => handleChoiceClick(choice)}
            >
              {choice.choice}
            </Button>
          ))}
        </Stack>
      )}

      {/* Results section */}
      {showResults && post?.choices && post.choices.length > 0 && (
        <Stack spacing={1} sx={{ mt: 2 }}>
          <Typography variant="subtitle2" color="text.secondary">
            Results ({pollData?.results?.total_votes ?? 0} votes)
          </Typography>
          {post.choices.map((choice) => {
            const result = getResultForChoice(choice.id);
            const votes = result?.votes ?? 0;
            const percentage = getPercentage(votes);
            const isSelected = vote && vote?.choice_id === choice.id;

            return (
              <Box
                key={choice.id}
                onClick={() => handleChoiceClick(choice)}
                sx={{
                  cursor: post?.cancel_vote_allow ? "pointer" : "default",
                  border: "1px solid",
                  borderColor: isSelected ? "primary.main" : "divider",
                  borderRadius: 1,
                  p: 1.5,
                }}
              >
                <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
                  <Typography variant="body2" fontWeight={isSelected ? 600 : 400}>
                    {choice.choice}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {percentage}% ({votes})
                  </Typography>
                </Stack>
                <LinearProgress
                  variant="determinate"
                  value={percentage}
                  color={isSelected ? "primary" : "inherit"}
                />
              </Box>
            );
          })}
        </Stack>
      )}
    </PostSingle>
  );
}